import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"
import { useGetConfigMutation } from "../../../api/services"

const Notes = () => {
    const [bottomText, setBottomText] = useState('')
    const [getConfig] = useGetConfigMutation();

    useEffect(() => {
        getConfig("UniversiteliAkbankli.Landing.Bottom")
            .unwrap()
            .then((payload) => {
                if (!payload.IsError) {
                    setBottomText(payload.configValue)
                }
            })
    }, [getConfig])
    return (
        <Page padding={false}>
            <Panel hasFooter={false} noHeader className="notes-container">
                <Block dangerouslySetInnerHTML={{ __html: bottomText }} />
            </Panel>
        </Page>
    )
}

export default Notes
